import InputCheckboxComponent from './InputCheckboxComponent';

export default InputCheckboxComponent;
